var map = {
	"./en": 5181,
	"./en.d": 9437,
	"./en.d.ts": 9437,
	"./en.js": 5181,
	"./ja": 2267,
	"./ja.d": 5691,
	"./ja.d.ts": 5691,
	"./ja.js": 2267,
	"./ko": 3460,
	"./ko.d": 2968,
	"./ko.d.ts": 2968,
	"./ko.js": 3460,
	"./vi": 2423,
	"./vi.d": 4927,
	"./vi.d.ts": 4927,
	"./vi.js": 2423
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 712;